import { useShortIdContext } from '@air/provider-short-id';

import { usePublicShowcaseContext } from '~/providers/PublicShowcaseProvider';
import { usePublicTableViewItems } from '~/swr-hooks/gallery/tableView/usePublicTableViewItems';

/**
 * Live `/a` board-drill table items. ShortUrl mixed list scoped to the page's collection (or the
 * link root). Edit + Preview supply `useShowcaseEditorBoardTableViewItems` on the layout contract.
 */
export const usePublicShowcaseBoardTableViewItems = () => {
  const { activePage } = usePublicShowcaseContext();
  const { objectId } = useShortIdContext();

  return usePublicTableViewItems({ collectionId: activePage?.pageId ?? objectId });
};
